var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card h-100"},[_c('div',{staticClass:"card-header py-2"},[_c('h6',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.title))])]),_c('div',{staticClass:"card-body"},[(_vm.fixed)?_c('div',{staticClass:"widget-chart",style:({ height: _vm.height + 'px' })},[_vm._t("default")],2):_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }